const settingsPrefix = '@settings';

export const DELIVERABLES_PERIOD = () => `${settingsPrefix}/deliverablesPeriod`;

export const DELIVERABLES_START_DATE = () => `${settingsPrefix}/deliverablesStartDate`;

export const DELIVERABLES_END_DATE = () => `${settingsPrefix}/deliverablesEndDate`;

export const DELIVERABLES_STATUS = () => `${settingsPrefix}/deliverablesStatus`;

export const PER_DIEM_REPORT_START_DATE = () => `${settingsPrefix}/accountingStartDate`; // cannot change value because of backwards compatibility

export const PER_DIEM_REPORT_END_DATE = () => `${settingsPrefix}/accountingEndDate`; // cannot change value because of backwards compatibility

export const WORK_ORDER_SELECTED_DUE_DATE = () => `${settingsPrefix}/workOrderSelectedDueDate`;

export const DAILY_TIP_SECTION_COLLAPSED = () => `${settingsPrefix}/dailyTipSectionCollapsed`;

export const WEEKLY_VIEW_START_DUE_DATE = () => `${settingsPrefix}/weeklyViewStartDueDate`;

export const WEEKLY_VIEW_END_DUE_DATE = () => `${settingsPrefix}/weeklyViewEndDueDate`;

export const CUSTOMER_SUPPORT_UNIQUE_ID = () => `${settingsPrefix}/customerSupportUniqueId`;

export const INVENTORY_TAB = () => `${settingsPrefix}/inventoryTab`;

export const TOAST = () => `${settingsPrefix}/toasts`;

export const WORK_ORDER_SORT = () => `${settingsPrefix}/scheduleBoardSort`;

export const PAYROLL_REPORT_START_DATE = () => `${settingsPrefix}/payrollReportStartDate`;

export const PAYROLL_REPORT_END_DATE = () => `${settingsPrefix}/payrollReportEndDate`;

export const PAYROLL_REPORT_PERIOD = () => `${settingsPrefix}/payrollReportPeriod`;

export const WORK_ORDERS_REPORTS_START_DATE = () => `${settingsPrefix}/workOrdersReportsStartDate`;

export const WORK_ORDERS_REPORTS_END_DATE = () => `${settingsPrefix}/workOrdersReportsEndDate`;

export const WORK_ORDERS_REPORTS_PERIOD = () => `${settingsPrefix}/workOrdersReportsPeriod`;

export const DELIVERABLE_RESOURCE_ACTIVE_TAB_ID = () => `${settingsPrefix}/deliverableResourceActiveTabId`;

export const EXPANDED_DELIVERABLE_ID = () => `${settingsPrefix}/expandedDeliverableId`;

export const EXPANDED_DELIVERABLE_SUBMISSION_ID = () => `${settingsPrefix}/expandedDeliverableSubmissionId`;

export const EXPANDED_DELIVERABLE_ASSIGNMENT_ID = () => `${settingsPrefix}/expandedDeliverableAssignmentId`;

export const COMMUNICATION_HISTORY_START_DATE = () => `${settingsPrefix}/communicationHistoryStartDate`;

export const COMMUNICATION_HISTORY_END_DATE = () => `${settingsPrefix}/communicationHistoryEndDate`;

export const COMMUNICATION_HISTORY_PERIOD = () => `${settingsPrefix}/communicationHistoryPeriod`;

export const EMPLOYEE_STATUS_HISTORY_START_DATE = () => `${settingsPrefix}/employeeStatusHistoryStartDate`;

export const EMPLOYEE_STATUS_HISTORY_END_DATE = () => `${settingsPrefix}/employeeStatusHistoryEndDate`;

export const EMPLOYEE_STATUS_HISTORY_PERIOD = () => `${settingsPrefix}/employeeStatusHistoryPeriod`;

export const EQUIPMENT_STATUS_HISTORY_START_DATE = () => `${settingsPrefix}/equipmentStatusHistoryStartDate`;

export const EQUIPMENT_STATUS_HISTORY_END_DATE = () => `${settingsPrefix}/equipmentStatusHistoryEndDate`;

export const EQUIPMENT_STATUS_HISTORY_PERIOD = () => `${settingsPrefix}/equipmentStatusHistoryPeriod`;

export const JOB_WORK_SUMMARY_START_DATE = () => `${settingsPrefix}/jobWorkSummaryStartDate`;

export const JOB_WORK_SUMMARY_END_DATE = () => `${settingsPrefix}/jobWorkSummaryEndDate`;

export const JOB_WORK_SUMMARY_PERIOD = () => `${settingsPrefix}/jobWorkSummaryPeriod`;

export const PURCHASE_ORDER_START_DATE = () => `${settingsPrefix}/purchaseOrderStartDate`;

export const PURCHASE_ORDER_END_DATE = () => `${settingsPrefix}/purchaseOrderEndDate`;

export const PURCHASE_ORDER_PERIOD = () => `${settingsPrefix}/purchaseOrderPeriod`;

export const PURCHASE_ORDER_SEARCH_TEXT = () => `${settingsPrefix}/purchaseOrderSearchText`;

export const ORDER_SEARCH_TEXT = () => `${settingsPrefix}/orderSearchText`;

export const TOOL_REPAIR_SEARCH_TEXT = () => `${settingsPrefix}/ToolRepairSearchText`;

export const ORDER_PAGE_SIZE = () => `${settingsPrefix}/orderPageSize`;

export const TOOL_REPAIR_PAGE_SIZE = () => `${settingsPrefix}/ToolRepairPageSize`;

export const PURCHASE_ORDER_PAGE_NUMBER = () => `${settingsPrefix}/purchaseOrderPageNumber`;

export const ORDER_PAGE_NUMBER = () => `${settingsPrefix}/orderPageNumber`;

export const TOOL_REPAIR_PAGE_NUMBER = () => `${settingsPrefix}/ToolRepairPageNumber`;

export const ACCOUNTING_INVOICES_START_DATE = () => `${settingsPrefix}/accountingInvoicesStartDate`;

export const ACCOUNTING_INVOICES_END_DATE = () => `${settingsPrefix}/accountingInvoicesEndDate`;

export const ACCOUNTING_INVOICES_PERIOD = () => `${settingsPrefix}/accountingInvoicesPeriod`;

export const ACCOUNTING_INVOICES_STATUS = () => `${settingsPrefix}/accountingInvoicesStatus`;

export const JOBS_INVOICES_START_DATE = () => `${settingsPrefix}/jobsInvoicesStartDate`;

export const JOBS_INVOICES_END_DATE = () => `${settingsPrefix}/jobsInvoicesEndDate`;

export const JOBS_INVOICES_PERIOD = () => `${settingsPrefix}/jobsInvoicesPeriod`;

export const JOBS_INVOICES_STATUS = () => `${settingsPrefix}/jobsInvoicesStatus`;

export const ORDER_START_DATE = () => `${settingsPrefix}/orderStartDate`;

export const ORDER_END_DATE = () => `${settingsPrefix}/orderEndDate`;

export const ORDER_PERIOD = () => `${settingsPrefix}/orderPeriod`;

export const ORDER_STATUS = () => `${settingsPrefix}/orderStatus`;

export const WORK_REQUEST_STATUS = () => `${settingsPrefix}/workRequestStatus`;

export const FIELD_REPORT_FULL_TABLE_START_DATE = (companyId: string) => `${settingsPrefix}/fieldReportFullTableStartDate/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_END_DATE = (companyId: string) => `${settingsPrefix}/fieldReportFullTableEndDate/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_PERIOD = (companyId: string) => `${settingsPrefix}/fieldReportFullTablePeriod/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_PAGE_NUMBER = (companyId: string) => `${settingsPrefix}/fieldReportFullTablePageNumber/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_SEARCH_TEXT = (companyId: string) => `${settingsPrefix}/fieldReportFullTableSearchText/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_MAIN_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableMainFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_JOB_ID = (companyId: string) => `${settingsPrefix}/fieldReportFullTableJobId/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_SELECTED_ROW = (companyId: string) => `${settingsPrefix}/fieldReportFullTableSelectedRow/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_SUPERINTENDENTS_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableSuperintendentsFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_PROJECT_MANAGER_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableProjectManagerFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_JOBS_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableJobsFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_CREW_TYPE_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableCrewTypeFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_REVIEW_STATUS_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableReviewStatusFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_WORK_SUMMARY_STATUS_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableWorkSummaryStatusFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_REQUIRES_ATTENTION_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableRequiresAttentionFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_EXCLUDE_CANCELLED_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableExcludeCancelledFilter/${companyId}`;

export const FIELD_REPORT_FULL_TABLE_ASSIGNMENT_FILTER = (companyId: string) => `${settingsPrefix}/fieldReportFullTableAssignmentFilter/${companyId}`;

export const ORDER_REPORT_START_DATE = () => `${settingsPrefix}/orderReportStartDate`;

export const ORDER_REPORT_END_DATE = () => `${settingsPrefix}/orderReportEndDate`;

export const ORDER_REPORT_PERIOD = () => `${settingsPrefix}/orderReportPeriod`;

export const ORDER_REPORT_PAGE_NUMBER = () => `${settingsPrefix}/orderReportPageNumber`;

export const ORDER_REPORT_SEARCH_TEXT = () => `${settingsPrefix}/orderReportSearchText`;

export const EXPENSE_REPORT_SEARCH_TEXT = () => `${settingsPrefix}/expenseReportSearchText`;

export const EXPENSE_REPORT_START_DATE = () => `${settingsPrefix}/expenseReportStartDate`;

export const EXPENSE_REPORT_END_DATE = () => `${settingsPrefix}/expenseReportEndDate`;

export const EXPENSE_REPORT_PERIOD = () => `${settingsPrefix}/expenseReportPeriod`;

export const EXPENSE_REPORT_PAGE_NUMBER = () => `${settingsPrefix}/expenseReportPageNumber`;

export const ORDERS_TAB = () => `${settingsPrefix}/ordersTab`;

export const JOB_TRACKING_START_DATE = () => `${settingsPrefix}/jobTrackingStartDate`;

export const JOB_TRACKING_END_DATE = () => `${settingsPrefix}/jobTrackingEndDate`;

export const JOB_TRACKING_PERIOD = () => `${settingsPrefix}/jobTrackingPeriod`;

export const WORK_SUMMARY_DETAILS_BULK_EDIT_STATUS_WARNING = () => `${settingsPrefix}/workSummaryDetailsBulkEditStatusWarning`;
